<template>
  <div class="rwo no-gutters">
    <div class="d-flex col-12 justify-content-center align-items-center">
      <div class="d-flex flex-fill flex-column">
        <table class="table table-bordered">
          <thead>
            <tr class="discountTitle">
              <th></th>
              <th>折扣區名稱</th>
              <th>
                加購區對象
              </th>
              <!-- <th>加購區對象</th> -->
              <th>折價／扣</th>
              <th>金額</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in buyfullDisData" :key="index">
            <!--eslint-disable-next-line vue/require-v-for-key-->
            <tr v-for="(sitem, sindex) in item.sub">
              <!-- :rowspan="item.dis_extra_setting.extra_data.length" -->
              <td v-if='sindex==0' :rowspan="item.sub.length">
                <button v-b-modal.modal_newDiscount2 type="button" class="btn btn-outline-secondary"
                  @click="editTempData(item)">
                  管理
                </button>
              </td>
              <td class="p-0 align-content-center" style='vertical-align:middle' v-if='sindex==0'
                :rowspan="item.sub.length">
                {{item.title}}
              </td>
              <td style='vertical-align:middle'>
                {{sitem.name}}
              </td>
              <td style='vertical-align:middle'>{{lang.dis_list[sitem.method]}}</td>
              <td style='vertical-align:middle'>{{sitem.off}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-modal id="modal_newDiscount2" hide-header size="lg" ok-title="儲存" cancel-title="取消">
        <div class="d-flex flex-column flex-fill">
          <span>【編輯】</span>
          <table class="table table-bordered">
            <thead>
              <tr style="background-color: rgb(197, 197, 197);">
                <th>折扣區名稱</th>
                <th>{{edit_dis_list.title}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="background-color: rgb(197, 197, 197);">設定加購區及金額</td>
                <td>
                  <div class="d-flex flex-column">
                    <div class="d-flex">
                      <b-form-checkbox v-model="edit_dis_list.extra" :value="true"
                        :unchecked-value="false">
                        本區設為
                        <span class="border">加購品</span>
                      </b-form-checkbox>
                      <small>（本區不可單獨買，需另買加購其他標區商品同時結帳，僅於購物車加購區開放購買）</small>
                    </div>
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            <button type="button" class="btn btn-outline-secondary">新增</button>
                          </th>
                          <th>加購區對象</th>
                          <th>折價／折扣</th>
                          <th>啟用</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in edit_dis_list.sub" :key="index">
                          <td :rowspan="edit_dis_list.sub.length" v-if="index === 0">
                            <button @click="edit()" type="button" class="btn btn-outline-secondary">
                              編輯
                            </button>
                          </td>
                          <template v-if="isEdit">
                            <td>
                              <select class="form-control">
                                <option>紅標區</option>
                                <option selected>黃標區</option>
                                <option>藍標區</option>
                                <option>棕標區</option>
                              </select>
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <div>
                                  <select v-model="item.method" class="form-control">
                                    <option value="off">折價</option>
                                    <option value="discount">折扣</option>
                                  </select>
                                </div>
                                <div v-if="item.method === 'off'" class="d-flex align-items-center">
                                  <b-form-input></b-form-input>
                                  <span>元</span>
                                </div>
                                <div v-else-if="item.method === 'discount'"
                                  class="d-flex align-items-center">
                                  <b-form-select :options="discountRange"></b-form-select>
                                  <span>折</span>
                                </div>
                              </div>
                            </td>
                            <td>
                              <b-form-checkbox v-model="item.enable" :value="true"
                                :unchecked-value="false">
                              </b-form-checkbox>
                            </td>
                          </template>
                          <template v-if="!isEdit">
                            <td>{{item.name}}</td>
                            <td>{{`${lang.dis_list[item.method]}${item.off}`}}</td>
                            <td>{{lang.dis_list[item.enable]}}</td>
                          </template>
                        </tr>
                        <!-- <tr>
                          <template v-if="isEdit">
                            <td>
                              <select class="form-control">
                                <option>紅標區</option>
                                <option selected>黃標區</option>
                                <option>藍標區</option>
                                <option>棕標區</option>
                              </select>
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <div>
                                  <select v-model="discountType_modal" class="form-control">
                                    <option value="discount_price">折價</option>
                                    <option value="discount">折扣</option>
                                  </select>
                                </div>
                                <div v-if="discountType_modal === 'discount_price'"
                                  class="d-flex align-items-center">
                                  <b-form-input></b-form-input>
                                  <span>元</span>
                                </div>
                                <div v-else-if="discountType_modal === 'discount'"
                                  class="d-flex align-items-center">
                                  <b-form-select :options="discountRange"></b-form-select>
                                  <span>折</span>
                                </div>
                              </div>
                            </td>
                            <td>
                              <b-form-checkbox value="accepted" unchecked-value="not_accepted">
                              </b-form-checkbox>
                            </td>
                          </template>
                          <template v-if="!isEdit">
                            <td>黃標區</td>
                            <td>折＄2600元</td>
                            <td>是</td>
                          </template>
                        </tr> -->
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import plus from '@/js/cartManage/plus';

export default plus;
</script>

<style lang="scss">

</style>
